import 'twin.macro';
import { SubHeader } from '@teetsh/app/src/components/SubHeader';
import React, { useState } from 'react';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import Button from '@teetsh/app/src/components/Buttons/Button';
import isBefore from '@teetsh/app/src/utils/time/isBefore';
import { useResendConfirmationEmail } from '@teetsh/app/src/queries/useSendConfirmEmail';
import { ExclamationTriangleIcon as Exclamation } from '@heroicons/react/20/solid';
import subMinutes from 'utils/time/subMinutes';
import { useTranslation } from 'react-i18next';

export function shouldDisplaySubHeader(
  emailConfirmed: boolean,
  createdAt?: Date,
) {
  if (emailConfirmed) {
    return false;
  }
  return createdAt && isBefore(createdAt, subMinutes(new Date(), 10));
}

export function ConfirmEmailHeader() {
  const { emailConfirmed, email, createdAt } = useUser();
  const resendConfirmationEmail = useResendConfirmationEmail();
  const [t] = useTranslation(['common']);
  const [isSending, setIsSending] = useState<boolean>(false);
  if (!shouldDisplaySubHeader(emailConfirmed, createdAt)) {
    return null;
  }
  return (
    <SubHeader>
      <div tw="flex justify-center items-center text-white text-base">
        <div tw="font-extrabold flex items-center mr-3 text-base">
          <div tw="mr-3">
            <Exclamation tw="h-5 w-5 text-white" aria-hidden="true" />
          </div>
          <div tw="mr-3">{t('common:subheader.emailNotConfirmed')}</div>
          <Button
            intent="primary"
            loading={isSending}
            small
            onClick={() => {
              setIsSending(true);
              resendConfirmationEmail({ email }).finally(() =>
                setIsSending(false),
              );
            }}
          >
            {t('common:subheader.resendConfirmationEmail')}
          </Button>
        </div>
      </div>
    </SubHeader>
  );
}
